import * as PIXI from 'pixi.js';
import Color from '../../utils/Color';
import DraggablePreset from './DraggablePreset';
import {
  getCenterX,
  getCenterY,
  getFixAboveY,
  getFixBelowY,
  getFixBottomY,
  getFixLeftX,
  getFixRightX,
  getFixTopY,
} from '../../utils/CoordinateCalculator';

export default class DebugText extends DraggablePreset {
  constructor(app) {
    super(app);

    this.text = new PIXI.Text('TEXT');

    this.textTL = new PIXI.Text('TL');
    this.textTC = new PIXI.Text('TC');
    this.textTR = new PIXI.Text('TR');

    this.textCL = new PIXI.Text('CL');
    this.textCC = new PIXI.Text('CC');
    this.textCR = new PIXI.Text('CR');

    this.textBL = new PIXI.Text('BL');
    this.textBC = new PIXI.Text('BC');
    this.textBR = new PIXI.Text('BR');

    this.textA = new PIXI.Text('A');
    this.textB = new PIXI.Text('B');

    this.gMaskedText = new PIXI.Text('graphic mask');
    this.gMaskedText.mask = new PIXI.Graphics();

    this.sMaskedText = new PIXI.Text('sprite mask');
    this.sMaskedText.mask = new PIXI.Sprite(PIXI.Texture.WHITE);

    this.texts = [
      this.textTL,
      this.textTC,
      this.textTR,
      this.textCL,
      this.textCC,
      this.textCR,
      this.textBL,
      this.textBC,
      this.textBR,
      this.textA,
      this.textB,
    ];

    this.container.addChild(
      ...this.texts,
      this.gMaskedText,
      this.sMaskedText.mask,
      this.sMaskedText
    );

    this.tick = 0;
  }

  // TODO: split in to root setup and timeline setup
  update(model) {
    super.update(model);

    this.texts.forEach((text) => {
      // eslint-disable-next-line no-param-reassign
      text.style.fontSize = this.fontSize;
    });

    this.setDraggableRoot(this.fontSize * 4, this.fontSize * 8);

    this.textTL.x = getFixLeftX(this.textTL, this.root);
    this.textTL.y = getFixTopY(this.textTL, this.root);

    this.textTC.x = getCenterX(this.textTC, this.root);
    this.textTC.y = getFixTopY(this.textTC, this.root);

    this.textTR.x = getFixRightX(this.textTR, this.root);
    this.textTR.y = getFixTopY(this.textTR, this.root);

    this.textCL.x = getFixLeftX(this.textCL, this.root);
    this.textCL.y = getCenterY(this.textCL, this.root);

    this.textCC.x = getCenterX(this.textCC, this.root);
    this.textCC.y = getCenterY(this.textCC, this.root);

    this.textCR.x = getFixRightX(this.textCR, this.root);
    this.textCR.y = getCenterY(this.textCR, this.root);

    this.textBL.x = getFixLeftX(this.textBL, this.root);
    this.textBL.y = getFixBottomY(this.textBL, this.root);

    this.textBC.x = getCenterX(this.textBC, this.root);
    this.textBC.y = getFixBottomY(this.textBC, this.root);

    this.textBR.x = getFixRightX(this.textBR, this.root);
    this.textBR.y = getFixBottomY(this.textBR, this.root);

    this.textA.x = getCenterX(this.textA, this.root);
    this.textA.y = getFixAboveY(this.textA, this.root);

    this.textB.x = getCenterX(this.textB, this.root);
    this.textB.y = getFixBelowY(this.textB, this.root);

    this.gMaskedText.style.fontSize = this.fontSize / 2;
    this.gMaskedText.style.fill = 0x00ff00;
    this.gMaskedText.x = getFixLeftX(this.gMaskedText, this.root);
    this.gMaskedText.y = getFixBelowY(this.gMaskedText, this.root);

    this.sMaskedText.style.fontSize = this.fontSize / 2;
    this.sMaskedText.style.fill = 0x00ff00;
    this.sMaskedText.x = getFixRightX(this.sMaskedText, this.root);
    this.sMaskedText.y = getFixBelowY(this.gMaskedText, this.root);
    this.setMaskOnText(this.sMaskedText);
  }

  render() {
    super.render();
    this.tick = this.tick > 100 ? 0 : this.tick + 1;

    this.graphics
      .lineStyle(2, 0xff00ff)
      .drawRect(this.root.x, this.root.y, this.root.width, this.root.height);

    // For the fun of it
    // this.graphics
    //   .lineStyle(2, Color.WHITE)
    //   .drawStar(this.root.x, this.root.y, 5, this.root.width / 4 + this.tick);

    this.graphics
      .lineStyle(1, 0x00ffff)
      .drawRect(
        this.textBL.x,
        this.textBL.y,
        this.textBL.width,
        this.textBL.height
      );

    /*
     * To keep masks in sync with the object its masking during
     * moving or scaling, the mask can either be a graphic mask
     * and the bounds are live updated from the text, or it is
     * a Sprite mask and will be bound to the container.
     *
     * The key being the bounds must be added to the container.
     */
    this.gMaskedText.mask
      .clear()
      .beginFill(Color.toNumber(Color.WHITE))
      .drawShape(this.gMaskedText.getBounds())
      .endFill();
  }
}
